import * as d3 from 'd3';
import { ItemFormat } from '../interfaces';
import { ElementRender } from './ElementeRenderer';

export class CrosshairLine extends ElementRender {
    private _listeners: { [event: string]: (d: [number, number], selection: d3.Selection<any>) => void }
        = {};

    constructor(selection: d3.Selection<any>) {
        super(selection, 'crosshair-line crosshair-group');
        const self = this;
        this.container()
            .append('rect')
            .classed('crosshair-rectangle', true)
            .on('mouseenter', function (d) {
                const m = d3.mouse(this);
                self.container()
                    .select('line')
                    .classed('hidden-group', true);
                if (self._listeners['mouseenter']) {
                    self._listeners['mouseenter'](m, d3.select(this));
                }
            })
            .on('mousemove', function (d) {
                const m = d3.mouse(this);
                if (self._listeners['mousemove']) {
                    self._listeners['mousemove'](m, d3.select(this));
                }
            })
            .on('mouseout', function (d) {
                const m = d3.mouse(this);
                self.container()
                    .select('line')
                    .classed('hidden-group', true);
                if (self._listeners['mouseout']) {
                    self._listeners['mouseout'](m, d3.select(this));
                }
            });
        this.container()
            .append('line')
            .classed('crosshair', true);
    }

    addListener(eventName: string, callback: (d: [number, number], selection: d3.Selection<ItemFormat>) => void) {
        this._listeners[eventName] = callback;
        return this;
    }

    removeListener(eventName: string) {
        delete (this._listeners[eventName]);
        return this;
    }

    render(d: ItemFormat) {
        const selection = this.container()
            .classed('hidden-group', !this.visible());
        selection.select('rect.crosshair-rectangle')
            .attr('width', this.width())
            .attr('height', this.height());
        if (d) {
            selection.select('line')
                .classed('hidden-group', false)
                .attr('x1', d.x + d.width / 2)
                .attr('x2', d.x + d.width / 2)
                .attr('y1', 0)
                .attr('y2', this.height());
        } else {
            selection.select('line')
                .classed('hidden-group', true);
        }

    }
}